var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-between",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-form-input', {
    attrs: {
      "size": "lg",
      "placeholder": "search job name..."
    },
    model: {
      value: _vm.filters.search,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "search", $$v);
      },
      expression: "filters.search"
    }
  }), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('refetch');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })]), _c('b-button', {
    staticClass: "d-flex align-items-center mx-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('toggleFilter');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders"
  }), _c('p', {
    staticClass: "text-truncate m-0"
  }, [_vm._v(" Filter Data ")])]), _c('b-button', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('resetFilter');
      }
    }
  }, [_c('p', {
    staticClass: "text-truncate m-0"
  }, [_vm._v("Reset Filter")])])], 1)]), _c('FilterMaintenancePreview', {
    attrs: {
      "filters": _vm.filters
    }
  }), _c('b-col', [!_vm.maintenance.isLoading ? [_vm.view_style === 'list' ? [_c('ProgressList', {
    attrs: {
      "maintenance": _vm.maintenance,
      "canAdd": _vm.canAdd,
      "canApprove": _vm.canApprove,
      "canReview": _vm.canReview,
      "loadPage": _vm.viewMenu
    },
    on: {
      "refetch": function refetch($event) {
        return _vm.$emit('refetch');
      },
      "viewDetailMaintenance": function viewDetailMaintenance(e) {
        return _vm.viewDetailMaintenance(e.id, e.type);
      },
      "onApprove": function onApprove(id) {
        return _vm.viewDetailMaintenance(id, 'ON_APPROVE');
      },
      "onReview": function onReview(id) {
        return _vm.viewDetailMaintenance(id, 'ON_REVIEW');
      },
      "onPostpone": function onPostpone(row) {
        _vm.modalPostpon.data = row;
        _vm.modalPostpon.show = true;
      }
    }
  })] : _vm._e()] : [_c('div', {
    staticClass: "py-5 w-100 d-flex justify-content-center"
  }, [_c('b-spinner', {
    attrs: {
      "label": "Spinning"
    }
  })], 1)]], 2), _c('b-sidebar', {
    attrs: {
      "id": "view-detail-maintenance",
      "title": "View Job Maintenance",
      "width": _vm.actionMaintenanceSidebar == 'VIEW_DETAIL' ? '50%' : '100%',
      "backdrop-variant": "dark",
      "right": "",
      "backdrop": "",
      "shadow": "",
      "header-class": "bg-white"
    },
    model: {
      value: _vm.viewDetailMaintenanceSidebar,
      callback: function callback($$v) {
        _vm.viewDetailMaintenanceSidebar = $$v;
      },
      expression: "viewDetailMaintenanceSidebar"
    }
  }, [[_vm.viewDetailMaintenanceSidebar ? _c('ViewMaintenanceDetail', {
    attrs: {
      "isEdit": _vm.isEdit,
      "maintenance-id": _vm.selectedMaintenanceId,
      "action": _vm.actionMaintenanceSidebar
    },
    on: {
      "save": function save($event) {
        return _vm.closeDetailMaintenance();
      },
      "close": function close($event) {
        return _vm.closeDetailMaintenance();
      },
      "onApprove": _vm.onApprove,
      "onReview": _vm.onReview
    }
  }) : _vm._e()]], 2), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Postpone Maintenance",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: _vm.modalPostpon.show,
      callback: function callback($$v) {
        _vm.$set(_vm.modalPostpon, "show", $$v);
      },
      expression: "modalPostpon.show"
    }
  }, [_c('PostponeForm', {
    attrs: {
      "maintenanceDetailData": _vm.modalPostpon.data
    },
    on: {
      "refetch": function refetch($event) {
        return _vm.$emit('refetch');
      },
      "close": function close() {
        _vm.modalPostpon.show = false;
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }